"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.user = void 0;
require("core-js/modules/es.symbol.description.js");
var types = _interopRequireWildcard(require("./types"));
var _constants = require("../../../utils/constants");
var _Types = require("../../../Types");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const initialState = {
  user: {
    token: null,
    tokenParams: {
      expiresOn: null
    },
    theme: _constants.defaultTheme,
    siteId: null,
    urls: _Types.urlsTypesDefault,
    errors: [],
    /** @todo: move webpSupport to Context */
    webpSupport: null
  }
};

// eslint-disable-next-line default-param-last
const user = exports.user = function user() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState.user;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case types.SET_USER:
      return _objectSpread(_objectSpread({}, state), payload);
    case types.SET_TOKEN:
      return _objectSpread(_objectSpread({}, state), {}, {
        token: payload
      });
    case types.SET_URLS:
      return _objectSpread(_objectSpread({}, state), {}, {
        urls: payload
      });
    case types.SET_WEBP_SUPPORT:
      return _objectSpread(_objectSpread({}, state), {}, {
        webpSupport: payload
      });
    case types.SET_TOKEN_PARAMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        tokenParams: _objectSpread(_objectSpread({}, state.tokenParams), payload)
      });
    case types.SET_THEME:
      return _objectSpread(_objectSpread({}, state), {}, {
        theme: payload
      });
    case types.RESET_USER_CORE:
      return initialState.user;
    default:
      return state;
  }
};